import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RegisterAuctionParam, GetRegisterDetail, CreateProduct } from './apiTypes'
import { Product, StatuteItem } from '../../modules/auction/types'
import { ListResponseFile } from '../../modules/profile/types';

interface StatuteByProduct extends StatuteItem {
    productCode: string,
    fileBienBan: ListResponseFile[]
}

export const productApi = createApi({
    reducerPath: 'productApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_URL + "/product",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("accessToken");
            if (token) {
                headers.set('authorization', `Bearer ${token}`)
            }
            return headers;
        }
    }),
    endpoints: (builder) => ({
        registerAuction: builder.mutation<GetRegisterDetail, RegisterAuctionParam>({
            query: (body) => ({
                url: `registerAuction`,
                method: 'POST',
                body: body
            }),
            transformResponse: (response: { body: GetRegisterDetail }, meta, arg) => {
                return response.body;
            },
        }),

        // getRegisterDetail: builder.query<Product, { productId: number, statuteId: number }>({
        //     query: (query) => `detail/${query.productId}/${query.statuteId}`,
        //     transformResponse: (response: { body: Product }, meta, arg) => {
        //         return response.body;
        //     },
        // }),

        uncareProduct: builder.mutation<any, { productId: number, statuteId: number }>({
            query: (query) => ({
                url: `uncare/${query.productId}/${query.statuteId}`,
                method: 'POST',
            }),
            transformResponse: (response: { body: any }, meta, arg) => {
                return response.body;
            }
        }),
        createProduct: builder.mutation<Product, CreateProduct>({
            query: (body) => ({
                url: 'create',
                method: 'POST',
                body,
            }),
            transformResponse: (response: { body: Product }, meta, arg) => {
                return response.body;
            },
        }),
        updateProduct: builder.mutation<Product, Partial<CreateProduct> & Pick<Product, 'productId'>>({
            query: ({ productId, ...body }) => ({
                url: `edit/${productId}`,
                method: 'PUT',
                body
            }),
            transformResponse: (response: { body: Product }, meta, arg) => {
                return response.body;
            },
        }),
        getProduct: builder.query<Product, { productId: number, statuteId?: number }>({
            query: (query) => `detail/${query.productId}?statuteId=${query.statuteId || ""}`,
            transformResponse: (response: { body: Product }, meta, arg) => {
                return response.body;
            },
        }),
        careProduct: builder.mutation<Product, { productId: number, statuteId: number }>({
            query: (query) => ({
                url: `care/${query.productId}/${query.statuteId}`,
                method: 'POST',
            }),
            transformResponse: (response: { body: Product }, meta, arg) => {
                return response.body;
            },
        }),
        deleteProduct: builder.mutation<Product, number>({
            query: (id) => ({
                url: `delete/${id}`,
                method: 'DELETE'
            }),
            transformResponse: (response: { body: Product }, meta, arg) => {
                return response.body;
            },
        }),
        getStatuteOfProduct: builder.query<StatuteByProduct[], number>({
            query: (id) => `statute-of-product?productId=${id}`,
            transformResponse: (response: { body: StatuteByProduct[] }, meta, arg) => {
                return response.body;
            },
        })
    })
})

export const {
    // useLazyGetRegisterDetailQuery,
    useRegisterAuctionMutation,
    useUncareProductMutation,
    useLazyGetProductQuery,
    useCreateProductMutation,
    useUpdateProductMutation,
    useCareProductMutation,
    useDeleteProductMutation,
    useLazyGetStatuteOfProductQuery
} = productApi
export default productApi
